import { Fragment, useEffect, useState } from "react";
import { Loader, PageLayout } from "../../components/index";
import {
  CenterVideo,
  AwardsAndRec,
  HomeLanding,
  HomeTestimonial,
  HomeTriInfo,
  HorizontalSec,
  Location,
  Emenities,
  ArtOfExotic,
} from "./index.js";
import axios from "axios";
import { baseUrl, getHomePage } from "../../utils/apiData";
import { Helmet } from "react-helmet";
import useExecuteContext from "../../utils/hooks/executeContext.js";
import useWindowHeight from "../../utils/hooks/windowHeight.js";
import useWindowWidth from "../../utils/hooks/windowWidth.js";

const Home = () => {
  const { locationData, setCurrentLocation } = useExecuteContext();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [galley, setGallery] = useState([]);
  const [testimonial, setTestimonial] = useState([]);
  const [site, setSite] = useState([]);
  const [projects, setProjects] = useState([]);
  const [homeSite, setHomeSite] = useState([]);
  const [amenities, setAmenities] = useState([]);

  // Page API Start
  const getHomeApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getHomePage}`);
      if (res?.data?.success) {
        setData(res?.data?.data.homepage);
        setGallery(res?.data?.data?.gallery);
        setTestimonial(res?.data?.data?.testimonial);
        setSite(res?.data?.data?.sites);
        setHomeSite(res?.data?.data?.homesites);
        setProjects(res?.data?.data?.projects);
        setAmenities(res?.data?.data?.amenities);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  // Page API End

  useEffect(() => {
    setCurrentLocation(locationData[0]);
    getHomeApi();
  }, []);

  const H = useWindowHeight();
  const W = useWindowWidth();

  return (
    <PageLayout>
      <Helmet>
        <title>Home | Exotic Group</title>
        <meta name="description" content="Home | Exotic Group" />
      </Helmet>

      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <HomeLanding
            title={data?.main_title}
            para={data?.main_description}
            videoId={data?.video}
            w={30}
            h={10}
          />
          <div id="second"></div>
          <HomeTriInfo dataList={projects}  title={data?.our_product_title}/>
          <ArtOfExotic 
          title={data?.art_title}
          para={data?.art_description}
          dataList={data?.art_images} />
          <HorizontalSec dataList={site} />
          <Emenities dataList={amenities} title={data?.amenties_title} />
          <AwardsAndRec dataList={galley} title={data?.award_title} />
          <HomeTestimonial
            dataList={testimonial}
            title={data?.testimonial_title}
          />

          <Location data={data} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default Home;
